import { useTitle } from "@hooks/useTitle";
import { Text, TextField, Title } from "@runwayhealth/runway-components-react";

type TripDescriptionFormProps = {
  title: string;
  reason: string;
  placeholder: string;
  tripDescription: string;
  setTripDescription: React.Dispatch<React.SetStateAction<string>>;
};

const TripDescriptionForm = ({
  title,
  reason,
  placeholder,
  tripDescription,
  setTripDescription,
}: TripDescriptionFormProps) => {
  useTitle("Trip Description");
  return (
    <>
      <Title size="giant">{title}</Title>
      <Text size="md">{reason}</Text>
      <TextField
        data-testid="trip-description-textarea"
        as="textarea"
        placeholder={placeholder}
        value={tripDescription}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
          setTripDescription(e.target.value);
        }}
        minLength={5}
      />
    </>
  );
};

export default TripDescriptionForm;
